import { Box, Button, Modal, Typography } from "@mui/material";
import { Dispatch, SetStateAction } from "react";

import { CustomerDisagreements } from "./types";

interface ModalCustomerCentralProps {
    currentCustomer?: CustomerDisagreements;
    openModal: boolean;
    setOpenModal: Dispatch<SetStateAction<boolean>>;
}

export function ModalCustomerCentral({
    currentCustomer,
    openModal,
    setOpenModal,
}: ModalCustomerCentralProps) {
    const handleCloseModal = () => setOpenModal(false);

    return (
        <Modal
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box
                sx={{
                    position: "absolute" as const,
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                }}
            >
                <h3 style={{ margin: "1px 0px" }}>
                    Inconsistências {currentCustomer?.name}
                </h3>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    {currentCustomer?.disagreements?.map(
                        (disagreement: { description: string }) => (
                            <div key={disagreement.description}>
                                <Typography variant="subtitle1" color="error">
                                    {` - ${disagreement.description}`}
                                </Typography>
                            </div>
                        )
                    )}
                </Typography>
                <Button color="primary" variant="contained">
                    Executar diagnostico completo cliente
                </Button>
            </Box>
        </Modal>
    );
}
